<template>
    <div class="packageDetail">
        <div class="main-container detail-container">
            <div class="rule">
                <div class="main-container-head">
                    <ul class="breadcrumb">
                        <!-- <li @click="routetokPage('/')"><a href="javascript:void(0)">酒店预订</a>></li> -->
                        <li @click="routetokPage('/packageList')"><a href="javascript:void(0)">度假产品</a>></li>
                        <li style="width: 765px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">{{details.ProductName}}</li>
                    </ul>
                    <div class="back-btn" @click="routetokPage('/packageList')">← 返回</div>
                </div>

                <Loading :isLogoLoading="isLogoLoading"></Loading>
                
                <div class="main-box" v-if="details">
                  <div class="main-left">
                    <!-- 标题 -->
                    <div class="hotel-head" id="floatTop">
                      <h3>{{ details.ProductName}}</h3>
                      <p class="tip">{{details.Tags[0]}}</p>
                    </div>
                    <!-- 图片 -->
                    <div class="hotel-img-content">
                      <div class="img-content-left">
                        <div class="big-img">
                          <ImgLoader :imgUrl="details.Imgs[0].ImgUrl" v-if="details.Imgs&&details.Imgs[0]"/>
                          <img src="./../../assets/img/defaultHotel.jpg" v-else>
                        </div>
                      </div>
                      <div class="img-content-right">
                        <div class="img-item" v-for="(img,index) in details.Imgs" v-show="index<5&&index!=0"
                            v-if="details.Imgs&&details.Imgs.length>0">
                          <ImgLoader :imgUrl="img.ImgUrl"/>
                        </div>
                        <div class="img-item" v-if="(!details.Imgs)||details.Imgs.length<5" v-for="item in numImg">
                          <img src="./../../assets/img/defaultHotel.jpg">
                        </div>
                      </div>
                    </div>
                    <!-- 套餐 -->
                    <div class="combo-box">
                        <div class="box-title">套餐类型</div>
                        <div v-for="SKU,index in SKUdata" :class="activeCombo==SKU.SkuId?'combo active':'combo'" @click="handleCombo(SKU)">{{SKU.SkuName}}</div>
                            <!-- <div class="tag" v-if="activeCombo==SKU.SkuId">{{packageBookInfo.SimpleDescribe}}</div> -->
                        
                    </div>
                    <div class="priceBarC" style="width: 100%;height: 50px;">
                      <div class="priceBar">
                        <div v-if="Price&&isCheck" style="color: #ff850d; margin-left: 10px;">
                          CNY <span class="price">{{ Price }}</span> /份
                        </div>
                        <div v-else>该套餐暂已售罄</div>
                        <div>
                          <div class="time" v-if="(dateIntervene(details.SaleStart)<=0)&&details.clockHour&&(details.clockHour<48)">
                            <span class="on" v-if="details.clockEnd">距结束 :</span>
                            <span class="under" v-html="details.clockEnd"></span>
                          </div>
                          <div class="time" v-if="dateIntervene(details.SaleStart)>0">
                              <span class="on" v-if="details.clockStart">距开售 :</span>
                              <span class="under" v-html="details.clockStart"></span>
                          </div>
                        </div>
                        <div class="submit" v-if="Price&&isCheck" @click="checkBookAble">立即抢购</div>
                        <div class="submit" v-else style="background-color: #5f5f5e;">立即抢购</div>
                      </div>
                    </div>
                  </div>
                </div>
              <div class="footer-box" v-if="details">
                  <div v-if="details.Type==2">
                    <div class="title">预售说明</div>
                    <div class="content" v-for="R,index in details.Rule" :key="index" v-if="index=='抢购时间'">
                      <span>{{index}}</span>：<span>{{R}}</span>
                    </div>
                    <div class="content" v-for="R,index in details.Rule" :key="index" v-if="index=='预约时间'">
                      <span>{{index}}</span>：<span>{{R}}</span>
                    </div>
                    <div class="content" v-if="packageBookInfo&&packageBookInfo.ValidStart&&packageBookInfo.ValidEnd">
                      <span>入住时间</span>：<span>{{packageBookInfo.ValidStart|dateToYMDline}}到{{packageBookInfo.ValidEnd|dateToYMDline}}</span>
                    </div>
                    <div class="content" v-if="packageBookInfo&&packageBookInfo.TimeLimitType">
                        <div style="margin-left: 5em;color:#eb3941;font-weight:bold;position: relative;">
                          <span style="position: absolute;top: 0;left: -5em;">适用限制：</span>
                          {{timeTip}}
                        </div>
                    </div>
                    <div class="content" v-for="R,index in details.Rule" :key="index" v-if="index=='自动取消'">
                      <span>{{index}}</span>：<span>{{R}}</span>
                    </div>
                  </div>


                  <div v-for="N,index in details.Notice" :key="index" v-if="index=='产品亮点'">
                    <div class="title">{{index}}</div>
                    <div class="content" v-html="N"></div>
                  </div>

                  <div v-for="N,index in details.Notice" :key="index" v-if="index=='购买须知'">
                    <div class="title">{{index}}</div>
                    <div class="content" v-html="N"></div>
                  </div>

                  <div>
                    <div class="title">图文介绍</div>
                    <div class="content" v-for="D,index in details.DetailImgs" :key="index">
                      <div class="detailTitle">{{D.Title}}</div>
                      <div class="detailImg"><img :src="D.ImgUrl" :alt="D.ImgUrl"/></div>
                      <div class="detailText" v-html="D.Describe"></div>
                    </div>
                  </div>

                  <div v-for="N,index in details.Notice" :key="index" v-if="index=='特别说明'">
                    <div class="title">{{index}}</div>
                    <div class="content" v-html="N"></div>
                  </div>
              </div>
              <!-- :style="{top:scroll+'px'}" -->
              <div class="date-right" :class="scroll?'positionFlex':''">
                  <div class="date-picker-box" v-if="dailyData&&dailyData.length>0">
                    <div class="hanleDate" v-if="hDate&&details.Type==1">您选择的出发日期为：<strong>{{hDate}}</strong></div>
                    <div v-if="AllowCancel==false&&details.Type==1" class="hanleDate">该日期订单一经确认，不可取消更改</div>
                    <div v-if="AllowCancel&&details.Type==1&&CancelDate" class="hanleDate">该日期订单最后可取消时间：{{CancelDate}}</div>
                    <div v-if="details.Type==2" class="hanleDate">
                      此产品支持预约前 <span style="font-size: 0.24rem;color: #fb8801;display: inline-block;padding: 3px;background: #fff6eb;"> 随时退 </span> ，过期未预约 <span style="font-size: 0.24rem;color: #fb8801;display: inline-block;padding: 3px;background: #fff6eb;"> 全额退 </span>。
                    </div>
                    <div class="hanleDate" v-if="details.Type==2">
                      <span>{{packageBookInfo.ReserveDay>0?'至少提前'+packageBookInfo.ReserveDay+'天预约，':(packageBookInfo.ReserveHour=='23:59'?'':'需当日'+packageBookInfo.ReserveHour+'前预定， ')}}</span>有效期至 <span style="font-weight: bold;">{{details.BookingEnd|dateToYMDline}}</span>
                    </div>
                    <div v-if="details.Type==2&&!isDaily&&dailyData&&dailyData.length>0" class="hanleDate">
                      产品为预售产品，您可以提前<span style="color: #2591fd; cursor: pointer;" @click="isShowDpb=true">查看可预约日期</span>。
                    </div>
                    <div v-if="(isShowDpb&&details.Type==2)||details.Type==1">
                    <div class="dpb-title">
                      <span @click="minus"><i class="iconfont icon-yuyin"></i></span>
                      <span>{{getMonths(number)}}</span>
                      <span @click="plus" style="transform: rotate(180deg);"><i class="iconfont icon-yuyin"></i></span>
                    </div>
                    <div class="dpb-week">
                      <table>
                        <thead>
                          <tr>
                            <th>日</th>
                            <th>一</th>
                            <th>二</th>
                            <th>三</th>
                            <th>四</th>
                            <th>五</th>
                            <th>六</th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                    <div class="dpb-week-days">
                      <div class="dpbwd-table" v-for="(item,index) in data" v-if="index==number">
                        <div class="dpbwd-table-items">
                          <table class="dpbwd-table-items-table" :class='details.Type==2?"flag":""'>
                            <tbody>
                              <tr v-for="week in item">	
                                <td :class="day.isActive?'active':(day.isInRange?'range':day.isDisable?'disable':'')" v-for="(day,i) in week" @click="select(day.item)">
                                  <div :class="i==0||i==6?'weekcolor page-table-item':'page-table-item'">
                                    <div class="page-table-text">
                                      {{day.day}}
                                    </div>
                                    <div class="page-table-note" v-if="day.item">{{day.item.Price}}</div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                  <div v-if="packageBookInfo&&packageBookInfo.SkuPieces.length>0">
                    <div class="title">产品包含</div>
                    <ul>
                      <li style="margin-bottom: 6px;" v-for="S,index in packageBookInfo.SkuPieces" :key="index"  v-html="S"></li>
                    </ul>
                  </div>
                </div>
            </div>
        </div>
        <Modal v-show="modal.show" :config="modal" @close="modal.show=false" @ok="modalOK"></Modal>
    </div>
</template>

<script>
import ImgLoader from "./../../common/cmpnt/imgLoader/imgLoader.vue"; //图片异步加载+效果
import DatePicker from "./comm/datePicker.vue"; //日期(单选)
import Loading from "./../../common/cmpnt/Loading/Loading.vue"; //缓冲
import Modal from "./../../common/cmpnt/Modal/modal.vue"; //跳转提示框
export default {
  name: "PackageDetails",
  components: {
    ImgLoader,
    DatePicker,
    Loading,
    Modal
  },
  data: function() {
    return {
      data:'',
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      begin: "",
      end: "",
      hDate: "",
      dailyData: "",
      number: 0,
      isLogoLoading: false,
      ProductId: this.$route.query.ProductId,
      packageBookInfo: "",
      details: "",
      SKUdata: "",
      Name: "",
      isDaily: false,
      ShowSKU: false,
      activeCombo: "",
      Price: "",
      isCheck: true,
      timeTip:'',
      Token: "",
      AllowCancel: "",
      CancelDate: "",
      modal: {
        show: false,
        config: {}
      },
      modalType: "book",
      scroll: false,
      isShowDpb:false
    };
  },
  watch: {},
  mounted() {
    this.detailData();
    window.addEventListener('scroll',this.handleScroll)
  },
  beforeDestroy(){ window.removeEventListener("scroll",this.handleScroll) },
  computed:{
    numImg(){
      var num = ''
      var arr = [];
      if(this.details.Imgs&&this.details.Imgs.length>0){
        num = 5 - this.details.Imgs.length
        for (var i = 0; i < num; i++) {
          arr.push(i);
        }
        return arr;
      }else {
        for (var i = 0; i < 5; i++) {
          arr.push(i);
        }
        return arr;
      }
    }
  },

  methods: {
    handleScroll(){
      const scrollTop = window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop||0
      const elC = document.querySelector('.priceBarC')
      const el = document.querySelector('.priceBar')
      const offsetTop = elC.offsetTop
      const windowH = window.innerHeight
      const high = offsetTop-windowH
      if(high>0&&scrollTop <= (high+130)){
        el.style.position = 'fixed'
        el.style.bottom = 0
      } else {
        el.style.position = 'static'
        el.style.bottom = 'auto'
      }
            if(scrollTop>140){
              this.scroll = true
            }else if(scrollTop<=140){
              this.scroll = false
            }
    },
    //减1
    minus() {
      if (this.number == 0)return;
      this.number -= 1;
    },
    //加1
    plus() {
      if (this.number >= 5)return;
      this.number += 1;
    },
    modalOK() {
      if (this.modalType == "book") {
        this.$router.push("/packageBook");
      } else {
        this.routeToDetails(this.currentHotelInfo);
      }
    },
    //打开详情
    routeToDetails(item) {
      window.open("#/packageDetails?ProductId==" + item.ProductId, "_blank");
    },

    checkBookAble() {
      var that = this;
      if(that.details.Type==2){
        this.$router.push("/packageBook");
        return
      }
      if (!that.packageBookInfo) {
        that.error({ title: "提示", content: "您尚未选购套餐" });
        return;
      }
      var dateTime
      if(that.hDate){
        dateTime = new Date(that.hDate)
        dateTime = dateTime.setDate(dateTime.getDate()+1)
        dateTime = new Date(dateTime)
        dateTime = that.dateToYMDline(dateTime)
      }
      // that.isSubmit = true;
      var param = {
        token: that.details.Type==2?that.packageBookInfo.Token:that.Token,
        Count: 1,
        CheckIn: that.hDate||that.getDate(0),
        CheckOut: dateTime||that.getDate(1)
      };
      that
        .postRequest({
          url: that.Api.getPackageCheck,
          params: param
        })
        .then(res => {
          // that.isSubmit = false;
          if (res.IsSuccess) {
            that.dao.set(
              "packageBookInfo",
              JSON.stringify(this.packageBookInfo)
            );
            this.$router.push("/packageBook");
          } else {
            that.error({ title: "提示", content: res.Msg || "不能预订" });
          }
        });
    },



    detailData() {
      var that = this;
      that.dao.set("packageDetailId", JSON.stringify(that.ProductId));
      var params = {
        productId: that.ProductId
      };
      that.isLogoLoading = true
      that
        .postRequest({
          url: that.Api.getPackageDetail,
          params: params
        })
        .then(res => {
          that.isLogoLoading = false
          if (res && res.IsSuccess) {
            that.details = res.Result;
            if (that.details.Imgs&&that.details.Imgs.length > 10) {
              that.details.Imgs = that.details.Imgs.splice(0, 10);
            }
            that.dao.set("packageDetails", JSON.stringify(that.details));
            that.timeLoop(
              that.details,
              that.details.SaleStart,
              that.details.SaleEnd
            );
            that.getSKUs(params);
            that.$nextTick(() => {
              if(localStorage.getItem('lang')=='t'){
                that.$zh_tran(localStorage.getItem('lang'))
              }         
            })
          } else {
            this.details = "";
            this.error(
              { title: "提示", content: res.Msg || "产品已过期！" },
              function() {
                window.history.go(-1);
              }
            );
          }
        });
    },

    getSKUs(params) {
      var that = this;
      that.ShowSKU = true;
      that
        .postRequest({
          url: that.Api.getPackageSKUs,
          params: params
        })
        .then(res => {
          if (res && res.IsSuccess) {
            var data = res.Result;
            var arr = [];
            data.forEach(item => {
              item.SKU.Token = item.Token;
              arr.push(item.SKU);
            });
            that.SKUdata = arr;
            that.handleCombo(that.SKUdata[0]);
            that.$nextTick(() => {
              if(localStorage.getItem('lang')=='t'){
                that.$zh_tran(localStorage.getItem('lang'))
              }         
            })
          } else {
            that.SKUdata = "";
            // that.error({ title: "提示", content: res.Msg || "暂无套餐可售！" });
          }
          that.ShowSKU = false;
        });
    },

    handleCombo(SKU) {
      var that = this
      this.Name = SKU.SkuName;
      this.activeCombo = SKU.SkuId;
      // if (SKU.Price && Number(SKU.Price)) {
      //   this.Price = Number(SKU.Price).toFixed(2);
      // }
      switch (SKU.TimeLimitType) {
        case 1:
          this.timeTip = "周末、平日通用(周一,周二,周三,周四,周五,周六,周日)";
          break;
        case 2:
          this.timeTip = "平日适用(周一,周二,周三,周四,周五)";
          break;
        case 3:
          this.timeTip = "平日适用(周日,周一,周二,周三,周四)";
          break;
        case 4:
          this.timeTip = "周末适用(周五,周六)";
          break;
        case 5:
          this.timeTip = "周末适用(周六,周日)";
          break;
        case 6:
          this.timeTip = "周五适用";
          break;
        case 7:
          this.timeTip = "周六适用";
          break;
        case 8:
          this.timeTip = "周日适用";
          break;
        case 9:
          this.timeTip = "平日适用(周日,周一,周二,周三,周四,周五)";
          break;
        case 10:
          this.timeTip = "平日适用(周一,周二,周三,周四)";
          break;
      }
      this.packageBookInfo = SKU;
      this.getPackageDaily(SKU);
      this.ShowSKU = false;
      that.$nextTick(() => {
        if(localStorage.getItem('lang')=='t'){
          that.$zh_tran(localStorage.getItem('lang'))
        }         
      })
    },

    //获取价格日历
    getPackageDaily(sku) {
      var that = this;
      var start = "";
      if (
        that.getDays(that.dateToYMDline(sku.ValidStart), that.getDate(0)) > 0
      ) {
        start = that.getDate(0);
      } else {
        start = that.dateToYMDline(sku.ValidStart);
      }
      var params = {
        HotelID: sku.HotelId,
        RoomID: sku.RoomId,
        RPID: sku.RpId,
        RateID: sku.RateId,
        ProductID: sku.ProductId,
        SKUID: sku.SkuId,
        Start: start,
        End: that.dateToYMDline(sku.ValidEnd)
      };
      that.isDaily = true;
      that
        .postRequest({
          url: that.Api.getPackagePrices,
          params: params
        })
        .then(res => {
          that.isDaily = false;
          that.ShowSKU = false;
          if (res && res.IsSuccess) {
            var data = res.Result.reverse();
            var arr = [];
            data.forEach(item => {
              if (!item.Status) {
                if (item.IsAskRoom || (!item.IsAskRoom && item.Stock > 0)) {
                  item.isBook = true;
                } else {
                  item.isBook = false;
                }
              } else {
                item.isBook = false;
              }
              item.Date = item.Date.slice(0, 10);
              arr.push(item);
            });
            that.dailyData = arr;
            var index = 0;
            var flag = true;
            for (var i = 0; i < arr.length; i++) {
              if (arr[i].isBook && flag) {
                index = i;
                flag = false;
              }
            }
            if (arr.length - (index + 1) >= 5) {
              that.list = arr.slice(index, index + 5);
            } else {
              that.list = arr.slice(index);
            }

            if (that.details.Type == 1) {
              that.select(that.list[0],true);
            } else {
              that.packageBookInfo.HandleItem = that.list[0];
              that.dao.set(
                "packageBookInfo",
                JSON.stringify(this.packageBookInfo)
              );
              that.Token = that.list[0].Token
              that.Price = that.list[0].Price
              that.AllowCancel = that.list[0].AllowCancel
              that.CancelDate = that.list[0].CancelDate
              // 计算月份差
              var dt1=that.list[0].Date
              var dt2=that.getDate(0)
              dt1=dt1.split('-')
              dt1=parseInt(dt1[0])*12+parseInt(dt1[1])
              dt2=dt2.split('-')
              dt2=parseInt(dt2[0])*12+parseInt(dt2[1])
              var num=Math.abs(dt1-dt2)
              that.number = num
              var length = that.dailyData.length - 1;
              that.begin = that.dailyData[0].Date;
              that.end = that.dailyData[length].Date;
              that.tableDate();
            }
            that.$nextTick(() => {
              if(localStorage.getItem('lang')=='t'){
                that.$zh_tran(localStorage.getItem('lang'))
              }         
            })
          } else {
            this.dailyData = "";
            that.SKUdata.forEach(item => {
              item.active = false;
            });
            this.error({
              title: "提示",
              content: "该套餐已售罄！"
            });
            this.Price = "";
          }
        });
    },
    select(item,flag) {
      if (this.details.Type == 2) return;
      if (!item.isBook) return;
      
      this.isCheck = true;
      this.Price = item.Price;
      this.Token = item.Token;
      this.AllowCancel = item.AllowCancel;
      this.CancelDate = item.CancelDate;
      this.hDate = item.Date
      this.packageBookInfo.HandleItem = item;
      
      // if(!flag&&this.scroll) {
      //   window.scrollTo({
      //     top:80,
      //     behavior:'smooth'
      //   })
      // }

      // 计算月份差
      var dt1 = this.hDate;
      var dt2 = this.getDate(0);
      dt1 = dt1.split("-");
      dt1 = parseInt(dt1[0]) * 12 + parseInt(dt1[1]);
      dt2 = dt2.split("-");
      dt2 = parseInt(dt2[0]) * 12 + parseInt(dt2[1]);
      var num = Math.abs(dt1 - dt2);
      this.number = num;
      var length = this.dailyData.length - 1;
      this.begin = this.dailyData[0].Date;
      this.end = this.dailyData[length].Date;
      this.tableDate();
    },

    //初始化表格数据
    tableDate() {
      var monthLength = 6;
      var data = [];
      // var date = new Date();
      var year = this.year; //获取完整的年份(4位)
      var month = this.month; //获取当前月份
      // console.log(year,month,monthLength)

      for (var i = 0; i < monthLength; i++) {
        var y = month + i > 12 ? year + 1 : year;
        var m = month + i > 12 ? month + i - 12 : month + i;
        // console.log(y,m)
        var re = this.monthDate(y, m < 10 ? "0" + m : m);
        data.push(re);
      }
      this.data = data;
    },


    //将数据格式化表格日期格式
    monthDate(year, month) {
      var that = this
      //或取当前月份最后一天的日期
      var day = new Date(year, month, 0);
      var lastDay = day.getDate();
      //计算当前月份第一天是星期几
      var weekday = that.getWeekday(year + "-" + month + "-01");
      //定义存放当前月份的数组
      var data = [];
      //定义日期表格数组
      var result = [];
      //计算出当前月份每一天到数组中
      for (var day = 1; day <= lastDay; day++) {
        var day = day < 10 ? "0" + day : day;
        var date = year + "-" + month + "-" + day;
        var flag = true;
        var isInRange, isDisable, isActive;
        that.dailyData.forEach(item => {
          if (date == item.Date) {
            flag = false
            if(date == that.hDate) {
              isActive = true
            }else {
              isActive = false;
            }
            if(item.isBook){
              isInRange = true;
              isDisable = false;
            }else {
              isInRange = false;
              isDisable = true;
              isActive = false;
            }
            data.push({
              day,
              month,
              year,
              isActive,
              isInRange,
              isDisable,
              item
            });
          }
        });
        if (flag) {
            isActive = false;
            isInRange = false;
            isDisable = true;
            data.push({
              day,
              month,
              year,
              isActive,
              isInRange,
              isDisable,
            });
        }
      }

      //补全日期前几天
      for (var i = 0; i < weekday; i++) {
        data.unshift("");
      }
      //切成6行
      for (var i = 0, len = data.length; i < len; i += 7) {
        result.push(data.slice(i, i + 7));
      }
      //补全日期后几天
      var length = result[result.length - 1].length;
      if (length < 7) {
        for (var i = 0; i < 7 - length; i++) {
          result[result.length - 1].push("");
        }
      }
      return result;
    },

    //获取周几
    getWeekday(date) {
      // var nowDate = new Date();
      // var days = this.getDaysSize(nowDate, date);
      var mydate = new Date(date);
      var myday = mydate.getUTCDay(); //注:0-6对应为星期日到星期六
      return myday;
    },

    //获取天数差
    getDaysSize(s1, s2) {
      var s1 = new Date(s1);
      var s2 = new Date(s2);

      var days = s2.getTime() - s1.getTime();
      var time = parseInt(days / (1000 * 60 * 60 * 24));
      return time;
    },

    timeLoop(item, start, end) {
      var num = 1;
      var that = this;
      var end = that.dateIntervene(end);
      var start = that.dateIntervene(start);
      var time = setInterval(function() {
        num++;
        if (num >= end) {
          clearInterval(time);
        } else {
          var hour = that.betDateH(end - num);
          that.$nextTick(function() {
            if (start > 0) {
              that.$set(item, "clockStart", that.betDateFomate(start - num));
            } else if (start <= 0 && hour < 48) {
              that.$set(item, "clockHour", hour);
              that.$set(item, "clockEnd", that.betDateFomate(end - num));
            }
          });
        }
      }, 1000);
    },
    betDateH(time) {
      return Math.floor(time / 60 / 60);
    },
    dateIntervene(date) {
      var s1 = new Date().getTime();
      var s2 = new Date(date).getTime();
      return parseInt((s2 - s1 > 0 ? s2 - s1 : 0) / 1000);
    },
    betDateFomate(time) {
      var d, h, m, s;
      if (time >= 0) {
        d = Math.floor(time / 60 / 60 / 24);
        h = Math.floor((time / 60 / 60) % 24);
        m = Math.floor((time / 60) % 60);
        s = Math.floor(time % 60);
      }

      var intv =
        "<span>" +
        d +
        "</span> 天 <span>" +
        (h < 10 ? "0" + h : h) +
        "</span> : <span>" +
        (m < 10 ? "0" + m : m) +
        "</span> : <span>" +
        (s < 10 ? "0" + s : s);

      return intv;
    }
  }
};
</script>

<style scoped>
.weekcolor .page-table-text{
  color: #28c667;
  /* color: #fb8800; */
}
.active .weekcolor {
  color: #fff !important;
}
.dpb-title {
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: #edeef2;
    font-size: 15px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
}

.dpb-title i{
  color: #2391ff;
  padding: 5px;
  background-color: #fff;
  cursor: pointer;
}

.dpb-week > table {
  background: #fff;
  font-size: 13px;
  width: 100%;
  border-collapse: separate;
  table-layout: fixed;
}
.dpb-week > table > thead > tr > th {
  height: 30px;
  text-align: center;
  font-weight: 400;
  /* border-bottom: 1px solid #e0e0e0; */
  width: 14.28571%;
  vertical-align: middle;
}
.dpb-week-days {
  position: relative;
  width: 100%;
  height: 100%;
  /* overflow: auto; */
}
.dpbwd-table-month {
  height: 30px;
  display: -webkit-box;
  -webkit-box-align: center;
  -webkit-box-pack: center;
  font-size: 15px;
  font-weight: 700;
  background: hsla(210, 8%, 95%, 0.9);
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1;
  /* border-bottom: 1px solid #e0e0e0; */
}
.page-table-item {
  box-sizing: border-box;
  position: relative;
  /*display: -webkit-box;*/
  -webkit-box-orient: vertical;
  -webkit-box-align: center;
  -webkit-box-pack: end;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
}
.page-table-text {
  font-size: 13px;
  height: 15px;
  line-height: 15px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.page-table-note {
  color: #fb8800;
  font-size: 12px;
  height: 15px;
  line-height: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-style: inherit;
}
.page-table-note,
.page-table-text {
  display: block;
  width: 100%;
  text-align: center;
}

.active .page-table-note,
.active .page-table-text {
  color: #fff;
}
.dpbwd-table-items-table > tbody > tr > td.disable .page-table-text,
.dpbwd-table-items-table > tbody > tr > td.disable .page-table-note {
  color: #ccc !important;
  background: none !important;
}
.dpbwd-table-items-table > tbody > tr > td.range {
  background: #e8f4ff;
  cursor: pointer;
}
.dpbwd-table-items-table.flag > tbody > tr > td.range {
  background: #e8f4ff;
  cursor: not-allowed;
}
.dpbwd-table-items-table > tbody > tr > td.active {
  cursor: pointer;
  color: #fff;
  background: #2391ff;
}
.dpbwd-table-items-table > tbody > tr > td {
  height: 55px;
  width: 13.6%;
  position: relative;
  background-color: #f8f8f8;
  display: inline-block;
  margin: 1px;
  cursor: not-allowed;
}
.dpbwd-table-items-table {
  width: 100%;
  border-collapse: separate;
  table-layout: fixed;
}

.hanleDate{
  margin-bottom: 10px;
}

.packageDetail{
  min-height: 500px;
  /* margin-bottom: 200px */
}


</style>


// WEBPACK FOOTER //
// src/components/package/details.vue